import { createIntl, createIntlCache } from 'react-intl'
import { DEFAULT_LOCALE } from './locale'

const cache = createIntlCache()

const defaultIntl = createIntl({ locale: DEFAULT_LOCALE, defaultLocale: DEFAULT_LOCALE }, cache)

export default defaultIntl
